<div class="advanced-info-wrapper"
     [ngClass]="!isEditingEnabled ? 'is-not-editable' : 'is-editable'">
  @for (key of fillMasterNumbers(); track key) {
    <div class="input-container">
      <label [for]="key"
            [attr.data-test]="'material-master-number-'+ key + '-label'">
        {{ 'material-master-number.' + key | translate }}
      </label>
      <input
          [id]="key"
          type="text"
          class="basic-input"
          spellcheck="false"
          autocomplete="off"
          [disabled]="!isEditingEnabled"
          [attr.data-test]="'material-master-number-'+ key + '-input'"
          [(ngModel)]="$any(materialMasterData)[key]"
          [maxlength]="20"
          (input)="updateInputValuesAndStoreIt()"/>
    </div>
  }
</div>

